"use client";

import { SideDrawer } from "@/shared/components/SideDrawer";
import { MyOrdersPanel } from "./MyOrdersPanel";

/** Quantas compras o "Comprar de novo" do header oferece. */
const RECENT_ORDERS_LIMIT = 6;

interface RecentOrdersDrawerProps {
    open: boolean;
    onClose: () => void;
}

/**
 * "Comprar de novo" do header: as últimas compras no mesmo painel de meus
 * pedidos, para a pessoa escolher qual refazer. O card abre os detalhes e o
 * "Pedir novamente" de lá manda os itens ao carrinho — aí esta gaveta fecha e
 * fica só a do carrinho.
 *
 * Monte uma vez e controle por `open`: o SideDrawer só monta o corpo aberto,
 * então cada abertura busca o histórico de novo (compra recente aparece).
 */
export function RecentOrdersDrawer({ open, onClose }: RecentOrdersDrawerProps) {
    return (
        <SideDrawer open={open} onClose={onClose} title="Comprar de novo" aria-label="Últimas compras">
            {/* `@container`: o grid dos cards corta colunas pelo container. */}
            <div className="@container px-5 py-5">
                <MyOrdersPanel limit={RECENT_ORDERS_LIMIT} orderState="local" onRepeated={onClose} />
            </div>
        </SideDrawer>
    );
}
